import { render, staticRenderFns } from "./news20.vue?vue&type=template&id=19333c16&"
import script from "./news20.vue?vue&type=script&lang=js&"
export * from "./news20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports